// @flow

import React from "react";
import AppContainer from "views/app/Container";
import renderRoot from "./react-render-root";
import "moment/locale/es";
import $ from "jquery";

window.$ = $;

renderRoot(<AppContainer />);
